import { useState } from "react";
import ItemsSCP from "../../../../../../../Services/Data/SCP/ItemsSCP.js";
import ItemCategoriesSCP from "../../../../../../../Services/Data/SCP/ItemCategoriesSCP";
import ItemButton from "./Components/ItemButton";
import "./Inventory.css";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager.js";

const Inventory = ({serverId, getPlayerIds}) => {
    const serverRequests = new ServerRequests();

    const [selectedItems, setSelectedItems] = useState([]);
    const [, setRefresh] = useState("");

    const [search, setSearch] = useState("");
    
    const ChangeItemSelection = (item) =>{
        let items = selectedItems;

        const selectedItem = items.find((x) => x.id == item.id);

        if(selectedItem != null)
            items.splice(items.indexOf(item), 1);
        else
            items.push(item);

        setSelectedItems(items);
        setRefresh(new Date().toISOString())
    }

    const filterItems = (item, category) => {
        return item.categoryId == category.id && item.show;
    }

    const executeCommandWithItems = (command) => {
        let items = "";

        selectedItems.map(item => 
            items += `${item}.`
        );

        if(items.length > 0) {
            executeCommand(command, items);
        }
        else {
            AddToastNotification("Musisz wybrać przedmioty!", 0);
        }
        
    }

    const executeCommand = (command, additionalData) => {
        const playerIds = getPlayerIds();

        if(playerIds.length > 0) {
            const commandToExecute = `/${command} ${playerIds} ${additionalData}`;
        
            serverRequests.ExecuteCommand(serverId, commandToExecute, () => {
                AddToastNotification("Polecenie wysłane do wykonania!", 1);
            });
        }
        else
        {
            AddToastNotification("Musisz wybrać graczy!", 0);
        }
    }

    return (
        <>
            <h3 className="text-center">Select player(s), then select items you want to give to them and confirm your selection.</h3>
            <div className="flex flex-row-reverse">
                <input placeholder="Search Item..." className="input" onChange={e => setSearch(e.target.value)}></input>
            </div>
            <div>
                { ItemCategoriesSCP.map(category => 
                    <fieldset className="itemCategory">
                        <legend>{category.name}</legend>

                        { ItemsSCP.filter(item => filterItems(item, category)).map(item => 
                            <ItemButton search={search} item={item} selected={selectedItems.find(x => x.id == item.id)} changeItemSelection={ChangeItemSelection}/>
                        )}
                    </fieldset>
                )}
            </div>
            <div className="flex gap-2 mt-4">
                <div onClick={() => executeCommandWithItems("give")} className="remoteAdminButton flex-1 !text-[14px]">GRANT ITEM(S)</div>
                <div onClick={() => executeCommandWithItems("removeitem")} className="remoteAdminButton flex-1 !text-[14px]">REMOVE ITEM(S)</div>
                <div onClick={() => executeCommand("clear")} className="remoteAdminButton flex-1 !text-[14px]">CLEAR INVENTORY</div>
                <div onClick={() => executeCommand("disarm")} className="remoteAdminButton flex-1 !text-[14px]">DISARM PLAYER(S)</div>
                <div onClick={() => executeCommand("free")} className="remoteAdminButton flex-1 !text-[14px]">RELEASE HANDCUFFS</div>
                <div onClick={() => executeCommandWithItems("forceequip")} className="remoteAdminButton flex-1 !text-[14px]">FORCE-EQUIP</div>
            </div>
        </>
    )
}

export default Inventory;